<template>
    <div>
        <header class="header-wrapper">
            <div class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <div class="full">
            <div class="full-background"></div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="row">
                            <div class="col-md-5">
                                <div class="full-info">
                                    <div>
                                        <h1 class="full-info-title mb-2">{{$t('meta.pl_services.h1')}}</h1>
                                        <h4 class="full-info-title">{{$t('public.pl_services.main_title')}}</h4>
                                        <p class="full-info-text">{{$t('public.pl_services.main_description')}}</p>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="full-img">
                <img src="~img/3PL-services-small.jpg" :alt="$t('meta.pl_services.h1')"  :title="$t('meta.pl_services.h1')">
            </div>
        </div>

        <section class="banner-2 mt-5">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <p>{{$t('public.pl_services.info1')}}</p>
                        <p class="mb-5">{{$t('public.pl_services.info2')}}</p>
                    </div>
                    <div class="col-lg-12"><h3 class="h3-title mb-4">{{$t('public.pl_services.services_included')}}</h3></div>
                    <div class="col-lg-6">
                        <div class="banner-2-article-block bg-white pl-150">
                            <div class="banner-2-article-block-title">{{$t('public.pl_services.blocks[0].title')}}</div>
                            <div class="banner-2-article-block-content">
                                <div v-html="$t('public.pl_services.blocks[0].text')"></div>
                                <router-link
                                    class="blue-base-link"
                                    :to="{name: 'AdditionalService'}">{{$t('public.pl_services.blocks[0].btn')}}
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="banner-2-article-block">
                            <div class="banner-2-article-block-title">{{$t('public.pl_services.blocks[1].title')}}</div>
                            <p class="banner-2-article-block-content">{{$t('public.pl_services.blocks[1].text')}}</p>
                            <router-link
                                class="blue-base-link"
                                :to="{name: 'AdditionalService'}">{{$t('public.pl_services.blocks[1].btn')}}
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-lg-8 ">
                        <div class="banner-2-article-block">
                            <div class="banner-2-article-block-title">{{$t('public.pl_services.blocks[2].title')}}</div>
                            <div class="banner-2-article-block-content">
                                <div v-html="$t('public.pl_services.blocks[2].text')"></div>
                                <router-link
                                    class="blue-base-link"
                                    :to="{name: 'AdditionalService'}">{{$t('public.pl_services.blocks[2].btn')}}
                                </router-link>
                                <div class="mt-5">
                                    <router-link
                                        class="blue-base-link d-block"
                                        :to="{name: 'AdditionalService'}">{{$t('public.pl_services.btn_link1')}}
                                    </router-link>
                                    <router-link
                                        class="blue-base-link d-block"
                                        :to="{name: 'AdditionalService'}">{{$t('public.pl_services.btn_link3')}}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="main-box">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="boxiti-bullets mt-5 border-top">
                            <div class="boxiti-bullets-content">
                                <h3 class="h3-title mb-3">{{$t('public.pl_services.list_title')}}</h3>
                                <p>{{$t('public.pl_services.list_description')}}</p>
                                <ul class="list-circle mt-4">
                                    <li>
                                        <b>{{$t('public.pl_services.lists[0].title')}}</b>
                                        <div v-html="$t('public.pl_services.lists[0].text')"></div>
                                    </li>
                                    <li>
                                        <b>{{$t('public.pl_services.lists[1].title')}}</b>
                                        <div v-html="$t('public.pl_services.lists[1].text')"></div>
                                    </li>
                                    <li>
                                        <b>{{$t('public.pl_services.lists[2].title')}}</b>
                                        <div v-html="$t('public.pl_services.lists[2].text')"></div>
                                    </li>
                                    <li>
                                        <b>{{$t('public.pl_services.lists[3].title')}}</b>
                                        <div v-html="$t('public.pl_services.lists[3].text')"></div>
                                    </li>
                                    <li>
                                        <b>{{$t('public.pl_services.lists[3].title')}}</b>
                                        <div v-html="$t('public.pl_services.lists[3].text')"></div>
                                    </li>
                                </ul>
                            </div>
                            <div class="block-border-blue">{{$t('public.pl_services.container_title')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <try-it-section></try-it-section>

        <footer-component></footer-component>
    </div>
</template>

<script>
    import TryItSection from '~cp/Public/PublicComponets/TryItSection.vue'

    export default {
        name: 'AdditionalService',
        components: {
            TryItSection
        },
        beforeRouteEnter(from, to, next) {
            next((vm) => vm.$store.dispatch('changeStylesSpecialPage', 'additional-service'))
        },
        beforeRouteLeave(from, to, next) {
            this.$store.dispatch('changeStylesSpecialPage', '').then(() => next())
        },
        metaInfo() {
            return {
                title: this.$t('meta.pl_services.title'),
                meta: [
                    { vmid: 'description', name: 'description', content: this.$t('meta.pl_services.description') },
                ]
            }
        },
    }

</script>



// WEBPACK FOOTER //
// src/components/Public/AdditionalService.vue